import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Tooltip,
  OverlayTrigger, Spinner,
  Modal
} from "react-bootstrap";
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { WithContext as ReactTags } from "react-tag-input";
import Select from "react-select";
import {Link} from 'react-router-dom'
import {
  coachAddProgram,
  coachAddSkill,
  coachBenefits,
  coachDeleteProgram,
  coachDeleteSkill,
  coachProfessions,
  coachTags,
  getCategoryList,
} from "../../../utils/api";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";

const initialValues = {
  session_title: "",
  price: "",
  P_duration: "",
  no_of_session: "",
  duration: "",
  display_title: "",
  description: "",
};
const validationSchemaSingle = Yup.object().shape({
  session_title: Yup.string().required("Session Title is required"),
  price: Yup.number().required("Price is required"),
  P_duration: Yup.number().required("Duration is required"),
  display_title: Yup.string().required("Number of session is required"),
});

const validationSchemaMultiple = Yup.object().shape({
  session_title: Yup.string().required("Session Title is required"),
  price: Yup.number().required("Price is required"),
  duration: Yup.number().required("Duration is required"),
});

const EditProfileClients = (props) => {
  const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [programs, setprograms] = useState([]);
    const [tags, setTags] = useState([]);
    const [deletedTags, setdeletedTags] = useState([]);
    const [skill, setSkill] = useState([]);
    const [benefits, setbenefits] = useState({});
    const [professions, setprofessions] = useState(user?.professions);
    const [tagList, settagList] = useState("");
    const [sessionType, setSessionType] = useState("Single");
    const [dataArray, setDataArray] = useState([]);
    const [deletedSessions, setdeletedSessions] = useState([]);
    const [session_name, setSession_name] = useState("");
    const [session_duration, setSession_duration] = useState("");
    const [sessionNameError, setSessionNameError] = useState(false);
    const [sessionDuration, setSessionDuration] = useState(false);
    const [visible, setVisible] = useState(false);
    const [progVisible, setProgVisible] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [selectedDuration, setSelectedDuration] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const [isSubmitting, setisSubmitting] = useState(false);
    const [hovered, setHovered] = useState(false);
  
    useEffect(() => {
      const transformedProfession = user?.professions?.reduce(
        (acc, benefit, index) => {
          acc[index + 1] = benefit;
          return acc;
        },
        {}
      );
      setprofessions(transformedProfession);
    }, [user]);
  
    
    const onClickSave = async (values) => {
      try {
        // handle program
        setisSubmitting(true);
        // handle professions
        const professionString = Object.values(professions).join(", ");
        const professionData = new FormData();
        professionData.append("professions", professionString);
        await coachProfessions(professionData);
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message);
        setisSubmitting(false);
      }
  
      getUserFromToken();
      setisSubmitting(false);
    };
  
    const handleProfessions = (event) => {
      setprofessions({
        ...professions,
        [event.target.name]: event?.target?.value,
      });
    };
  
  return (
    <>
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Form>
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                <Form.Label className="title fs-20">Clients you can coach</Form.Label>
                <ul className="bc_list">
                  <li>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      rows={3}
                      name="1"
                      value={professions?.["1"]}
                      onChange={handleProfessions}
                      placeholder="Professions 1"
                    />
                  </li>
                  <li>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      rows={3}
                      name="2"
                      value={professions?.["2"]}
                      onChange={handleProfessions}
                      placeholder="Professions 2"
                    />
                  </li>
                  <li>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      rows={3}
                      name="3"
                      value={professions?.["3"]}
                      onChange={handleProfessions}
                      placeholder="Professions 3"
                    />
                  </li>
                  <li>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      rows={3}
                      name="4"
                      value={professions?.["4"]}
                      onChange={handleProfessions}
                      placeholder="Professions 4"
                    />
                  </li>
                  <li>
                    <Form.Control
                      className="mb-2"
                      type="text"
                      rows={3}
                      name="5"
                      value={professions?.["5"]}
                      onChange={handleProfessions}
                      placeholder="Professions 5"
                    />
                  </li>
                </ul>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileClients;